// ─── El entorno en el que corre el web (regla P13) ──────────────────────────
// El web no sabe si es producción o staging: lo dice VITE_FIREBASE_PROJECT_ID,
// que el build recibe por entorno. De ahí se deriva la URL de las funciones HTTP
// (resolver de dominios, feed del calendario). Si falta, el web NO arranca:
// caer a producción haría que un staging resolviera dominios y entregara
// calendarios con las funciones de producción.

/** Región de todas las funciones. Es la misma en todos los proyectos. */
const REGION = 'us-central1';

/** El proyecto de Firebase de este build. */
export function firebaseProjectId(): string {
  const id = import.meta.env['VITE_FIREBASE_PROJECT_ID'] as string | undefined;
  if (!id) {
    throw new Error(
      'VITE_FIREBASE_PROJECT_ID is not set: this build does not know which Firebase project it belongs to.',
    );
  }
  return id;
}

/** URL pública de las funciones HTTP de este proyecto. */
export function functionsBaseUrl(): string {
  return `https://${REGION}-${firebaseProjectId()}.cloudfunctions.net`;
}

/** El resolver de dominios propios. VITE_RESOLVER_URL lo reemplaza si existe
 *  (p. ej. para apuntar a un emulador). */
export function resolverUrl(): string {
  const override = import.meta.env['VITE_RESOLVER_URL'] as string | undefined;
  return override || `${functionsBaseUrl()}/resolveDomain`;
}

/** Se llama al arrancar: un build sin proyecto falla en el acto, no al primer
 *  dominio propio que haya que resolver. */
export function assertWebEnvironment(): void {
  firebaseProjectId();
}
